(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './curity-ssi-libs-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./curity-ssi-libs-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-verifiable-credentials'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-verifiable-credentials'.");
    }
    root['curity-ssi-libs-verifiable-credentials'] = factory(typeof this['curity-ssi-libs-verifiable-credentials'] === 'undefined' ? {} : this['curity-ssi-libs-verifiable-credentials'], this['kotlin-kotlin-stdlib'], this['curity-ssi-libs-core']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_io_curity_ssi_core) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.kb;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var toString = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.ha;
  var equals = kotlin_kotlin.$_$.ba;
  var ToString = kotlin_io_curity_ssi_core.$_$.m;
  var VOID = kotlin_kotlin.$_$.f;
  var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var enumEntries = kotlin_kotlin.$_$.p9;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var Enum = kotlin_kotlin.$_$.ie;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(StringCredential, 'StringCredential');
  initMetadataForClass(DictionaryCredential, 'DictionaryCredential');
  initMetadataForClass(IssuerURI, 'IssuerURI', VOID, VOID, [ToString]);
  initMetadataForInterface(IssuerObject, 'IssuerObject', VOID, VOID, [ToString, Dictionary]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(ClientIdScheme, 'ClientIdScheme', VOID, Enum, [ToString, Enum]);
  //endregion
  function StringCredential(value) {
    this.o2h_1 = value;
  }
  protoOf(StringCredential).toString = function () {
    return 'StringCredential(value=' + this.o2h_1 + ')';
  };
  protoOf(StringCredential).hashCode = function () {
    return getStringHashCode(this.o2h_1);
  };
  protoOf(StringCredential).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringCredential))
      return false;
    var tmp0_other_with_cast = other instanceof StringCredential ? other : THROW_CCE();
    if (!(this.o2h_1 === tmp0_other_with_cast.o2h_1))
      return false;
    return true;
  };
  function DictionaryCredential(value) {
    this.p2h_1 = value;
  }
  protoOf(DictionaryCredential).toString = function () {
    return 'DictionaryCredential(value=' + toString(this.p2h_1) + ')';
  };
  protoOf(DictionaryCredential).hashCode = function () {
    return hashCode(this.p2h_1);
  };
  protoOf(DictionaryCredential).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DictionaryCredential))
      return false;
    var tmp0_other_with_cast = other instanceof DictionaryCredential ? other : THROW_CCE();
    if (!equals(this.p2h_1, tmp0_other_with_cast.p2h_1))
      return false;
    return true;
  };
  function IssuerURI(value) {
    this.q2h_1 = value;
  }
  protoOf(IssuerURI).toString = function () {
    return this.q2h_1;
  };
  protoOf(IssuerURI).hashCode = function () {
    return getStringHashCode(this.q2h_1);
  };
  protoOf(IssuerURI).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IssuerURI))
      return false;
    var tmp0_other_with_cast = other instanceof IssuerURI ? other : THROW_CCE();
    if (!(this.q2h_1 === tmp0_other_with_cast.q2h_1))
      return false;
    return true;
  };
  function IssuerObject() {
  }
  var ClientIdScheme_PRE_REGISTERED_instance;
  var ClientIdScheme_DID_instance;
  var ClientIdScheme_X509_SAN_DNS_instance;
  var ClientIdScheme_X509_SAN_URI_instance;
  var ClientIdScheme_VERIFIER_ATTESTATION_instance;
  var ClientIdScheme_REDIRECT_URI_instance;
  var ClientIdScheme_ENTITY_ID_instance;
  function Companion() {
  }
  protoOf(Companion).r2h = function (clientIdScheme) {
    var _iterator__ex2g4s = get_entries().j();
    while (_iterator__ex2g4s.k()) {
      var cis = _iterator__ex2g4s.l();
      if (cis.u2h_1 === clientIdScheme) {
        return cis;
      }
    }
    throw IllegalArgumentException_init_$Create$('Unknown client id scheme: ' + clientIdScheme);
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function values() {
    return [ClientIdScheme_PRE_REGISTERED_getInstance(), ClientIdScheme_DID_getInstance(), ClientIdScheme_X509_SAN_DNS_getInstance(), ClientIdScheme_X509_SAN_URI_getInstance(), ClientIdScheme_VERIFIER_ATTESTATION_getInstance(), ClientIdScheme_REDIRECT_URI_getInstance(), ClientIdScheme_ENTITY_ID_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var ClientIdScheme_entriesInitialized;
  function ClientIdScheme_initEntries() {
    if (ClientIdScheme_entriesInitialized)
      return Unit_instance;
    ClientIdScheme_entriesInitialized = true;
    ClientIdScheme_PRE_REGISTERED_instance = new ClientIdScheme('PRE_REGISTERED', 0, 'pre-registered');
    ClientIdScheme_DID_instance = new ClientIdScheme('DID', 1, 'did');
    ClientIdScheme_X509_SAN_DNS_instance = new ClientIdScheme('X509_SAN_DNS', 2, 'x509_san_dns');
    ClientIdScheme_X509_SAN_URI_instance = new ClientIdScheme('X509_SAN_URI', 3, 'x509_san_uri');
    ClientIdScheme_VERIFIER_ATTESTATION_instance = new ClientIdScheme('VERIFIER_ATTESTATION', 4, 'verifier_attestation');
    ClientIdScheme_REDIRECT_URI_instance = new ClientIdScheme('REDIRECT_URI', 5, 'redirect_uri');
    ClientIdScheme_ENTITY_ID_instance = new ClientIdScheme('ENTITY_ID', 6, 'entity_id');
  }
  var $ENTRIES;
  function ClientIdScheme(name, ordinal, clientIdScheme) {
    Enum.call(this, name, ordinal);
    this.u2h_1 = clientIdScheme;
  }
  protoOf(ClientIdScheme).toString = function () {
    return this.u2h_1;
  };
  function ClientIdScheme_PRE_REGISTERED_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_PRE_REGISTERED_instance;
  }
  function ClientIdScheme_DID_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_DID_instance;
  }
  function ClientIdScheme_X509_SAN_DNS_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_X509_SAN_DNS_instance;
  }
  function ClientIdScheme_X509_SAN_URI_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_X509_SAN_URI_instance;
  }
  function ClientIdScheme_VERIFIER_ATTESTATION_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_VERIFIER_ATTESTATION_instance;
  }
  function ClientIdScheme_REDIRECT_URI_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_REDIRECT_URI_instance;
  }
  function ClientIdScheme_ENTITY_ID_getInstance() {
    ClientIdScheme_initEntries();
    return ClientIdScheme_ENTITY_ID_instance;
  }
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance;
  _.$_$.b = DictionaryCredential;
  _.$_$.c = StringCredential;
  _.$_$.d = IssuerObject;
  _.$_$.e = IssuerURI;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-verifiable-credentials.js.map
